var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "col-12 col-md-4 col-lg-3": !_vm.inTable } },
    [
      _c("ValidationProvider", {
        ref: "provider",
        attrs: {
          name: _vm.name,
          rules: Object.assign({}, _vm.mergedRules),
          slim: ""
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              var failedRules = ref.failedRules
              return [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm._selectedDate,
                      expression: "_selectedDate"
                    }
                  ],
                  ref: _vm.title + "_input",
                  class: [
                    "form-control",
                    _vm.focusClass,
                    _vm.getValidationErrorClasses(failedRules)
                  ],
                  attrs: {
                    id: _vm.name + "_input",
                    type: "text",
                    placeholder: _vm.placeholderValue,
                    "aria-labelledby": _vm.labelledBy ? _vm.labelledBy : null,
                    readonly: _vm.isDisabled,
                    "aria-readonly": _vm.isDisabled,
                    disabled: _vm.isDisabled,
                    "aria-disabled": _vm.isDisabled,
                    "aria-required": _vm.required,
                    "aria-invalid": _vm.required && errors.length > 0
                  },
                  domProps: { value: _vm._selectedDate },
                  on: {
                    focus: function($event) {
                      return _vm.touch()
                    },
                    change: function($event) {
                      return _vm.change()
                    },
                    blur: function($event) {
                      return _vm.updateOutput()
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return $event.target.blur()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm._selectedDate = $event.target.value
                    }
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }